// A chave `ce-auth` e o formato do que está dentro dela são contrato, não
// detalhe: no dia do corte da Fase 5 o navegador de quem já está logado vai
// abrir o painel novo com o objeto que o painel antigo gravou. Mudar o nome da
// chave ou o formato deslogaria o time inteiro de uma vez.
//
// O objeto é exatamente o que `auth.issueTokens` devolve (engine/src/auth.js).

export interface Credenciais {
  token: string;
  refresh: string;
  role: 'admin' | 'dev';
  email: string;
  expiresIn: number;
}

export const CHAVE_AUTH = 'ce-auth';

export function guardarCredenciais(c: Credenciais): void {
  localStorage.setItem(CHAVE_AUTH, JSON.stringify(c));
}

export function lerCredenciais(): Credenciais | null {
  // o try não é zelo excessivo: a chave pode ter sido editada à mão, ou ter
  // ficado de uma versão anterior. Tratar como deslogado é melhor que estourar
  // na primeira linha do boot e deixar a tela branca.
  try {
    const cru = localStorage.getItem(CHAVE_AUTH);
    if (!cru) return null;
    const v = JSON.parse(cru) as Partial<Credenciais>;
    return v && typeof v.token === 'string' && typeof v.refresh === 'string' ? (v as Credenciais) : null;
  } catch {
    return null;
  }
}

export function esquecerCredenciais(): void {
  localStorage.removeItem(CHAVE_AUTH);
}

/** A inicial do e-mail, como no avatar do painel atual. */
export const inicial = (email: string): string => (email || '?').trim().charAt(0).toUpperCase() || '?';
